import * as yup from 'yup';

export const contractVehicleDeregistrationFormValidationSchema = yup.object().shape({
    unsubscribeDate: yup.string().required().nullable(),
    files: yup
        .array()
        .of(yup.object())
        .test((arr) => arr.length > 0),
});
